// @ts-expect-error legacy
import Donut from "@/pages/rum/v2/details/graphs/DonutGraph";
import {RUMSection} from "@/pages/rum/v2/details/graphs/segments/SectionBtnGroup.tsx";
import {getSectionDef} from "@/pages/rum/v2/details/graphs/segments/tools.ts";
import {ReportSpec} from "@/pages/rum/v2/details/ReportDefType.ts";

interface SectionSegmentDonutProps {
  checkName: string;
  donut: JSON;
  section: RUMSection;
  reportSpec: ReportSpec;
  colors: string[];
}

export const SectionSegmentDonut = ({checkName, donut, section, reportSpec, colors}: SectionSegmentDonutProps) => {
  const sectionDef = getSectionDef(reportSpec, section);
  const data = donut || {};
  // @ts-expect-error legacy
  const keys = Object.keys(data).sort((a, b) => (data[b] || 0) - (data[a] || 0)); // Sort descending by feature value.
  keys.splice(5); // Allow max 5 results because we like tidy donuts here.
  keys.sort(); // Sort alphabetically to be consistent with trend graph.
  const featureColors = {};
  for (const [ix, key] of Object.entries(keys)) {
    // @ts-expect-error legacy
    const color = colors[ix % (colors.length - 1)];
    // @ts-expect-error legacy
    featureColors[color] = {key, name: key};
  }
  return (
    <Donut
      checkName={checkName}
      data={donut}
      header={sectionDef.donut.feature?.name}
      featureColors={featureColors}
      title={sectionDef.donut.series?.name}
    />
  );
};
